













































import { Component, Vue } from 'vue-property-decorator';
import api from '@/services/api';
import authorize, { Director } from '@/services/Authorize';
import UserProfile from '@/classes/UserProfile';
import {sprintf} from 'sprintf-js';
import {MetaState} from '@/store/MetaStore';
import UserNotification from '@/classes/UserNotification';


@Component
export default class NavBar extends Vue {

    private overrideUnlock: number = 0;

    get showMeta(): boolean {
        return 'prod' !== this.meta.env || this.meta.override;
    }

    get meta(): MetaState {
        return this.$store.getters['meta/getMeta']();
    }

    get activeProfile(): UserProfile {
        return this.$store.getters.getActiveProfile;
    }

    get greeting(): string {
        const profile = this.activeProfile;
        return null == profile ? 'User' : sprintf('Hello %s', profile.getFullName());
    }

    public logOut() {
        api().post('logout')
        .then(() => {
            this.$store.commit('setActiveProfile', undefined);
        })
        .then(() => {
            this.$router.push('login');
        });
    }

    private gotoHelp(): void {
        window.open('/help', '_blank');
    }

    private toggleMeta(): void {

        if (++this.overrideUnlock >= 5) {
            this.$store.dispatch('meta/toggleOverride');
            this.overrideUnlock = 0;
        }
    }

    private mounted(): void {
        this.$store.dispatch('meta/loadMeta');
        this.$store.dispatch('notifications/loadUserNotifications', true);
        this.$store.dispatch('notifications/loadReleaseNotes', true);
    }

    private get userNotifications(): UserNotification[] {
        const userNotifications: UserNotification[] | undefined = this.$store.getters['notifications/getViewableUserNotifications'];
        if (userNotifications !== undefined) {
            return userNotifications;
        } else {
            return [];
        }
    }
}
